import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkle, ArrowRight } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome, ${name.split(" ")[0]}!`);
      navigate("/onboarding");
    } else {
      toast.error(res.error || "Could not create account");
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream-50">
      <div className="flex items-center justify-center p-8 order-2 lg:order-1">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-2 mb-10">
            <Sparkle weight="fill" size={22} />
            <span className="font-serif text-2xl">Ava</span>
          </Link>
          <p className="text-[0.7rem] tracking-[0.3em] uppercase text-charcoal-500">Create your profile</p>
          <h1 className="font-serif text-4xl sm:text-5xl mt-3 text-charcoal-900">Your style story <em className="italic">starts here.</em></h1>
          <form onSubmit={submit} className="mt-10 space-y-6">
            <div>
              <label className="text-[0.65rem] tracking-[0.25em] uppercase text-charcoal-500">Your name</label>
              <input required value={name} onChange={(e) => setName(e.target.value)}
                data-testid="register-name-input"
                className="w-full bg-transparent border-0 border-b-2 border-cream-200 focus:border-charcoal-700 focus:outline-none py-2 text-lg"
                placeholder="e.g. Maya" />
            </div>
            <div>
              <label className="text-[0.65rem] tracking-[0.25em] uppercase text-charcoal-500">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email-input"
                className="w-full bg-transparent border-0 border-b-2 border-cream-200 focus:border-charcoal-700 focus:outline-none py-2 text-lg"
                placeholder="you@example.com" />
            </div>
            <div>
              <label className="text-[0.65rem] tracking-[0.25em] uppercase text-charcoal-500">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password-input"
                className="w-full bg-transparent border-0 border-b-2 border-cream-200 focus:border-charcoal-700 focus:outline-none py-2 text-lg"
                placeholder="at least 6 characters" />
            </div>
            <button type="submit" disabled={loading} data-testid="register-submit-button" className="btn-primary-pill w-full disabled:opacity-60">
              {loading ? "Creating…" : "Create account"}
              <ArrowRight className="ml-2" size={16} />
            </button>
          </form>
          <p className="mt-8 text-sm text-charcoal-600">
            Already joined? <Link to="/login" data-testid="go-login" className="text-charcoal-900 underline">Sign in</Link>
          </p>
        </div>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img
          src="https://images.unsplash.com/photo-1758900728025-3d70604871c9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxzdHlsaXNoJTIwY29uZmlkZW50JTIwd29tYW4lMjBmYXNoaW9ufGVufDB8fHx8MTc3NjYzMzE5N3ww&ixlib=rb-4.1.0&q=85"
          alt="Two stylish women"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute bottom-10 left-10 right-10 text-white">
          <p className="text-[0.65rem] tracking-[0.3em] uppercase opacity-80">Your profile, your rules</p>
          <h2 className="font-serif text-4xl mt-3 italic">No trends forced. No shame. Ever.</h2>
        </div>
      </div>
    </div>
  );
}
